"use strict";

/**
 * @function
 * @description handles Product Slider
 */
const handleProductSlider = () => {
    const $handleProductSlider = $(".js-product-slider");

    $handleProductSlider.each((i, el) => {
        const $this = $(el);

        if ($this.find(".js-asset-slider-item").length < 1) {
            $this.remove();
        }
    });
};


module.exports = handleProductSlider;
